import { render } from "./MessageRBody.vue?vue&type=template&id=3c18433e"
import script from "./MessageRBody.vue?vue&type=script&lang=js"
export * from "./MessageRBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__